module.exports = __webpack_public_path__ + "img/lsxvip.3befafe8.png";